const STORAGE_KEY = 'gravity-maze-progress';
const VERSION = 1;

function defaultState() {
  return {
    version: VERSION,
    bestTimes: {},
    lastPlayedLevel: 1,
    unlockedUpTo: 1,
  };
}

export class ProgressStore {
  constructor() {
    this.state = this._load();
  }

  _load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultState();
      const parsed = JSON.parse(raw);
      if (parsed.version !== VERSION) return defaultState();
      return {
        version: VERSION,
        bestTimes: parsed.bestTimes || {},
        lastPlayedLevel: parsed.lastPlayedLevel || 1,
        unlockedUpTo: parsed.unlockedUpTo || 1,
      };
    } catch {
      return defaultState();
    }
  }

  _save() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.state));
    } catch {
      // localStorage 不可用（隐私模式/配额满）→ 本次会话内存中仍有 this.state
    }
  }

  getBestTime(levelId) {
    const v = this.state.bestTimes[levelId];
    return typeof v === 'number' ? v : null;
  }

  recordTime(levelId, timeMs) {
    const prev = this.getBestTime(levelId);
    if (prev === null || timeMs < prev) {
      this.state.bestTimes[levelId] = timeMs;
    }
    if (levelId >= this.state.unlockedUpTo) {
      this.state.unlockedUpTo = levelId + 1;
    }
    this._save();
  }

  isUnlocked(levelId) {
    return levelId <= this.state.unlockedUpTo;
  }

  getLastPlayedLevel() {
    return this.state.lastPlayedLevel;
  }

  setLastPlayedLevel(levelId) {
    this.state.lastPlayedLevel = levelId;
    this._save();
  }
}
